import LearnitTagResourceListResultModel from '../../generated/types/model/resource/LearnitTagResourceListResultModel';

export default class LearnitTagResourceListResultViewModel extends LearnitTagResourceListResultModel {
  // For instructions on how to use ViewModels visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/155/ViewModels-Models-DTOs
}
